<template>
  <div class="layout-container">
    <div class="nav">
      <div class="nav_left">
        <img :src="registerIcon" alt="" />
        <span class="line">|</span>
        <span class="help_title">帮助中心</span>
      </div>
      <div class="nav_right">
        <el-autocomplete
          placeholder="请输入关键字，如：代码位管理"
          v-model="searchkey"
          class="input-with-select"
          style="width: 350px"
          prefix-icon="el-icon-search"
          :fetch-suggestions="querySearchAsync"
          @select="handleSelect"
        >
        </el-autocomplete>
        <!-- <a
          class="top-right"
          target="_blank"
          href="https://www.mediatom.cn/sdkdownload"
          ><i class="el-icon-download"></i><span></span></a
        > -->
        <div class="top-right" @click="skip">
          <i class="el-icon-download"></i>
          <span>SDK下载</span>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="content-left">
        <span class="menu-title">帮助文档</span>
        <sideMenu
          :menuList="menutree"
          :currentId="'' + currentBlogId"
          @changeBlog="changeBlog"
        />
      </div>
      <div class="container-right" v-if="blogKey">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import sideMenu from "@/components/sideMenu";
export default {
  components: { sideMenu },
  data() {
    return {
      searchkey: "",
      blogKey: Math.random().toString(),
    };
  },
  computed: {
    ...mapState([
      "title",
      "registerIcon",
      "menulist",
      "menutree",
      "currentBlogId",
    ]),
    restaurants() {
      return this.menulist.map((item) => ({
        value: item.title,
        id: item.id,
      }));
    },
  },
  watch: {
    $route: {
      handler(val) {
        val.query.blogid &&
          this.$store.commit("SET_CURRENTBLOG", val.query.blogid);
        this.blogKey = Math.random().toString();
        // !val.query.blogid &&
        //   this.menulist.length > 0 &&
        //   this.$router.push({
        //     query: {
        //       blogid: this.menulist[0].id,
        //     },
        //   });
      },
      immediate: true,
    },
    menulist: {
      handler(val, oldVal) {
        if (val.length > 0 && !this.$route.query.blogid) {
          this.$router.push({
            query: {
              blogid: val[0].id,
            },
          });
        }
      },
    },
  },
  methods: {
    skip() {
      window.open("https://app.mediatom.cn/#/user/login?to=sdkDownload");
    },
    querySearchAsync(queryString, cb) {
      const filterBlogs = this.restaurants.filter((item) =>
        item.value.includes(queryString)
      );
      cb(filterBlogs);
    },
    handleSelect(e) {
      this.$router.push({
        query: {
          blogid: e.id,
        },
      });
      this.searchkey = "";
    },
    changeBlog(e) {
      this.$router.push({
        query: {
          blogid: e,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.layout-container {
  .nav {
    background: #fff;
    z-index: 999;
    height: 72px;
    // border: 1px solid;
    box-shadow: 0 6px 12px hsl(0deg 0% 80% / 40%);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0px;
    position: fixed;
    width: 100%;
    top: 0;
    .nav_left {
      display: flex;
      align-items: center;
      img {
        margin-left: 20px;
        height: 45px;
      }
      .line {
        margin: 0 10px;
        font-size: 12px;
        color: #999;
      }
      .help_title {
        font-size: 14px;
        color: #444;
      }
    }
    .nav_right {
      margin-right: 30px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .top-right {
        margin: 0 10px;
        color: #36f;
        text-decoration: none;
        border: 1px solid;
        padding: 8px;
        border-radius: 8px;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        // i {
        //   line-height: 30px;
        //   vertical-align: top;
        //   margin-top: 3px;
        // }
      }
    }
  }
  .main {
    margin-left: 16vw;
    .content-left {
      min-width: 16vw;
      max-width: 16vw;
      background: #fafafa;
      overflow-y: auto;
      overflow-x: hidden;
      height: calc(100vh - 80px);
      position: fixed;
      left: 0;
      // border: 1px solid;
      top: 72px;
      &::-webkit-scrollbar {
        width: 7px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.03);
        background: rgba(0, 0, 0, 0.2);
      }
      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.03);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
      }

      .menu-title {
        margin: 100px 20px;
        line-height: 50px;
        font-size: 15px;
        font-weight: 600;
      }
    }
    .container-right {
      flex-grow: 1;
      overflow: hidden;
    }
  }
}
</style>
